<template>
  <v-container class="vh-footer bg-gray ps-re lynn-mobile lynn-web" fluid>
    <v-container class="pad nb mt15 mt-p3 web-contract">
      <div class="dw-box" v-if="feeAmount">
        <div class="bg">
          <Topbg />
        </div>
        <div class="text-box">
          <div class="tb-in">
            <div class="top-box">
              <strong>{{ thisYear }}년 {{ thisMonth }}월 관리비</strong>
              <a @click="$router.push({ name: 'mgmtFee' })" href="#none">
                <MoewW />
              </a>
            </div>
            <p>
              {{ feeAmount }}
            </p>
            <span
              >전월대비
              {{ feeDiffToLastMonth }}
            </span>
          </div>
        </div>
      </div>
      <div class="dw-box" v-if="serviceFeeAmount">
        <div class="bg">
          <Topbg />
        </div>
        <div class="text-box">
          <div class="tb-in">
            <div class="top-box">
              <strong
                >{{ serviceFeeThisYear }}년 {{ serviceFeeThisMonth }}월 서비스
                사용료</strong
              >
              <a @click="$router.push({ name: 'serviceFee' })" href="#none">
                <MoewW />
              </a>
            </div>
            <p>
              {{ serviceFeeAmount }}
            </p>
            <span
              >전월대비
              {{ serviceFeeDiffToLastMonth }}
            </span>
          </div>
        </div>
      </div>
      <router-link to="/facilityHome" v-if="showFacilityHome || isDYCIS">
        <div class="dw-sbox">
          <div class="bg">
            <img src="@/assets/images/dwelling/topbg2.png" />
          </div>
          <div class="text-box">
            <strong>시설 안내·예약</strong>
            <p>단지에 있는 시설들을 확인하고 예약할 수 있습니다</p>
          </div>
        </div>
      </router-link>
      <!-- 2024.11.01 신규 추가화면 -->
      <a
        @click="movetoLynnPass()"
        v-if="is_development || isSmartIotDoorEnabled"
      >
        <div class="dw-sbox type4">
          <div class="bg">
            <img src="@/assets/images/dwelling/lynnpass.png" />
          </div>
          <div class="text-box">
            <strong>출입문 개방</strong>
            <p>휴대폰으로 간편하게 출입문을 개방할 수 있습니다.</p>
          </div>
        </div>
      </a>
      <!-- 2024.11.01 신규 추가화면 -->
      <div @click="openDefectView('AFTER')" v-if="home.is_defect_after_open">
        <div class="dw-sbox type2">
          <div class="bg">
            <img src="@/assets/images/dwelling/topbg3.png" />
          </div>
          <div class="text-box">
            <strong>AS접수</strong>
            <p>AS 접수 및 접수 목록을 확인 할 수 있습니다</p>
          </div>
        </div>
      </div>
      <!-- 노크타운 앱 연결 -->
      <a @click="movetoNocktown()" v-if="showRentProjectMenu">
        <div class="dw-sbox typend">
          <div class="bg">
            <img src="@/assets/images/dwelling/nocktown-card-bg.png" />
          </div>
          <div class="text-box">
            <strong>노크타운 앱 이동</strong>
            <p>단지 내 커뮤니티 시설을 확인하고 예약할 수 있습니다.</p>
          </div>
        </div>
      </a>
      <div class="smart-box" v-if="home.is_iot_enabled">
        <div class="text-box">
          <strong>스마트홈</strong>
          <a @click="movetoFlutter()">
            <MoewB />
          </a>
        </div>
        <div class="btn-box">
          <button type="button" @click="callElevatorAction()">
            <span class="icon">
              <Eve />
            </span>
            <span class="text">엘리베이터</span>
          </button>
          <button type="button" @click="lightOffAction()">
            <span class="icon">
              <Light />
            </span>
            <span class="text">전체소등</span>
          </button>
        </div>
      </div>
      <div class="dw-board">
        <div class="dwb-title">
          <strong>단지소식</strong>
          <a
            @click="
              $router.push({
                name: 'noticeVillage',
                query: { type_sub_code: '' },
              })
            "
            href="#none"
          >
            <MoewB />
          </a>
        </div>
        <ul class="dwb-list">
          <li
            v-for="(item, idx) in notices"
            :key="'Education-card-' + idx"
            :item="item"
          >
            <router-link
              :to="{
                name: 'noticeInVillage',
                params: { id: item.id, type: 'notice' },
              }"
            >
              <a href="#none">{{ item.title }}</a>
            </router-link>
          </li>

          <li v-if="notices.length == 0" class="no-list">
            단지 소식이 없습니다
          </li>
        </ul>
      </div>
      <div class="dw-board mb0">
        <div class="dwb-title">
          <strong>입주민투표</strong>
          <a @click="$router.push({ name: 'voteList' })" href="#none">
            <MoewB />
          </a>
        </div>
        <ul class="dwb-vote">
          <li v-for="vote in voteList" :key="'vote' + vote.id">
            <a @click="checkAndMove(vote)">
              <div class="icons">
                <span :class="['date', { end: vote.is_done }]">{{
                  dayCalculate(vote.to_datetime)
                }}</span>
                <span
                  :class="['set', { end: vote.vote_yn == 'Y' || vote.is_done }]"
                  >{{
                    vote.vote_yn == "Y"
                      ? "투표완료" + "-" + vote.voter_name
                      : "미투표"
                  }}</span
                >
              </div>
              <p>
                {{ vote.title }}
              </p>
            </a>
          </li>
          <li v-if="voteList.length == 0" class="no-list">
            진행중인 투표가 없습니다.
          </li>
        </ul>
      </div>
      <div class="text-center" v-if="loadingBar">
        <v-progress-circular
          fullscreen
          indeterminate
          color="red"
          style="position: fixed; top: calc(50% - 16px); left: calc(50% - 16px)"
        ></v-progress-circular>
      </div>
    </v-container>
    <v-dialog v-model="votepopup" max-width="320">
      <v-card>
        <div class="vote-popup">
          <p class="vp-text">{{ votepopupmsg }}</p>
          <div class="vp-btnbox">
            <a href="#none" @click="votepopup = false">확인</a>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <SurveyDialog
      v-if="survey.dialog"
      :survey="survey"
      @close="survey.dialog = false"
    />
  </v-container>
</template>

<script>
import { getFacilityList } from "@/api/dwelling";
import {
  getBulletinList,
  getFee,
  getMonth,
  getServiceFee,
  getServiceFeeMonth,
  getVoteList,
} from "@/api/index";
import { callElevator, lightOff } from "@/api/smartLynn.js";
import Eve from "@/assets/images/dwelling/btn-eve.svg";
import Light from "@/assets/images/dwelling/btn-light.svg";
import MoewB from "@/assets/images/dwelling/more-black.svg";
import MoewW from "@/assets/images/dwelling/more-white.svg";
import Topbg from "@/assets/images/dwelling/topbg.svg";

import { checkSurvey } from "@/api/survey";
import SurveyDialog from "@/components/Survey/SurveyDialog";
import { LYNNLIFE_STORE_URL } from "@/utils/appVersion";

const NOCKTOWN_DEEP_LINK = "https://www.homeknocktown.co.kr/app/deep-link";
export default {
  components: {
    Topbg,
    Eve,
    Light,
    MoewW,
    MoewB,
    SurveyDialog,
  },
  name: "DwellingIntro",
  data() {
    return {
      votepopup: false,
      votepopupmsg: "투표는 세대주만 가능합니다",
      voteList: [],
      notices: [],
      onChange: false,
      fee: [], // 관리비
      feeAmount: "", // 관리비 총액
      serviceFee: [], // 서비스 사용료
      serviceFeeAmount: "", // 서비스 사용료 총액
      feeDiffToLastMonth: "", // 관리비 전월대비
      serviceFeeDiffToLastMonth: "", // 서비스 사용료 전월대비
      thisYear: "",
      thisMonth: "",
      serviceFeeThisYear: "",
      serviceFeeThisMonth: "",
      maxYear: "",
      maxMonth: "",
      loadingBar: false,
      localeStringOption: {
        style: "currency",
        currency: "KRW",
      },
      survey: {
        dialog: false,
        popup_period: null,
      },
      showFacilityHome: false,
    };
  },
  computed: {
    home() {
      return this.$store.getters.getTenantHome;
    },
    user() {
      return this.$store.getters.getUser;
    },
    is_development() {
      return process.env.NODE_ENV !== "production";
    },
    showRentProjectMenu(){
      /**
       * 임대프로젝트 통합테스트(운영)를 위해 테스트 단지만 메뉴 노출(TODO: 통합테스트 이후 삭제 예정)
       */
      if(this.is_development) return true;

      return this.home && (this.home.erp_village_id == "BQ00P0999D" || this.home.erp_village_id == "BQ00P0888D");
    },
    isSmartIotDoorEnabled() {
      /*
      BB00P0262D: 화성 비봉지구 우미 린
      */
      return this.home && this.home.is_smart_iot_door_enabled;
    },
    browserInfo() {
      return navigator.userAgent.toLowerCase();
    },
    is_app() {
      return this.browserInfo.indexOf("wikey_flutter") > 0;
    },
    isDYCIS() {
      /*
      2486 : 신진주 역세권
      3905 : 파주운정3차(파주 운정신도시 우미 린 파크힐스)
      */
      return (
        this.home &&
        (this.home.is_dycis_facility_enabled || this.home.dong_no == "999")
      );
    },
    facilityList() {
      return this.$store.getters.getFacilityList;
    },
    isServiceFeeEnabled() {
      return this.home && this.home.is_using_erp_service_fee;
    },
  },
  methods: {
    getVoteList() {
      getVoteList().then((res) => {
        this.voteList = res.data;
        console.log(this.voteList);
      });
    },
    lightOffAction() {
      this.loadingBar = true;
      lightOff()
        .then((result) => {
          console.log(result.data);
          this.loadingBar = false;
          this.$store.commit("SUCCESS", "전체소등 완료.");
        })
        .catch((err) => {
          console.log(err);
          this.$store.commit("ERROR", "작동되지 않았습니다.");
          this.loadingBar = false;
          return false;
        });
    },
    callElevatorAction() {
      this.loadingBar = true;
      callElevator()
        .then((result) => {
          console.log(result.data);
          this.loadingBar = false;
          this.$store.commit("SUCCESS", "엘리베이터를 호출하였습니다.");
        })
        .catch((err) => {
          console.log(err);
          this.$store.commit("ERROR", "작동되지 않았습니다.");
          this.loadingBar = false;
          return false;
        });
    },
    getFeeList() {
      this.loadingBar = true;
      getFee(this.home.id, this.thisYear, this.thisMonth)
        .then((result) => {
          console.log(result.data);
          this.loadingBar = false;
          this.fee = result.data;
          console.log(this.fee);
          try {
            this.feeAmount = this.fee[0].amount.toLocaleString(
              "ko-KR",
              this.localeStringOption,
            );
            let diffAmount = this.fee[0].diff_to_last_month;
            let raiseOrDown = "";
            if (diffAmount > 0) raiseOrDown = " 증가";
            else if (diffAmount < 0) {
              raiseOrDown = " 감소";
              diffAmount = diffAmount * -1;
            }
            this.feeDiffToLastMonth =
              diffAmount.toLocaleString("ko-KR", this.localeStringOption) +
              raiseOrDown;
          } catch (err) {
            console.log(err);
          }
        })
        .catch((err) => {
          // this.$store.commit("ERROR", "데이터가 없습니다.");
          this.loadingBar = false;
          this.setDate(1);
          return false;
        });
    },
    getServiceFeeList() {
      if (!this.isServiceFeeEnabled) return;

      getServiceFeeMonth(this.home.id)
        .then((result) => {
          this.serviceFeeThisYear = result.data.year;
          this.serviceFeeThisMonth = result.data.month;

          return getServiceFee(
            this.home.id,
            this.serviceFeeThisYear,
            this.serviceFeeThisMonth,
          );
        })
        .then((result) => {
          this.serviceFee = result.data;

          try {
            this.serviceFeeAmount = this.serviceFee[0].amount.toLocaleString(
              "ko-KR",
              this.localeStringOption,
            );
            let diffAmount = this.serviceFee[0].diff_to_last_month;
            let raiseOrDown = "";
            if (diffAmount > 0) raiseOrDown = " 증가";
            else if (diffAmount < 0) {
              raiseOrDown = " 감소";
              diffAmount = diffAmount * -1;
            }
            this.serviceFeeDiffToLastMonth =
              diffAmount.toLocaleString("ko-KR", this.localeStringOption) +
              raiseOrDown;
          } catch (err) {
            console.log(err);
          }
        })
        .catch((err) => {
          this.serviceFeeAmount = "";
        });
    },
    setDate(add) {
      let setDate = new Date(this.thisYear, this.thisMonth - 1);
      setDate.setMonth(setDate.getMonth() + add);

      let maxDate = new Date(this.maxYear, this.maxMonth - 1);

      if (setDate > maxDate) {
        // this.$store.commit("ERROR", "데이터가 없습니다.");
        return false;
      }
      this.thisYear = setDate.getFullYear();
      this.thisMonth = setDate.getMonth() + 1;
      this.getFeeList();
    },
    getNoticeList() {
      getBulletinList("type=BULLETIN_LINNLIFE_NOTICE&menu=VILLAGE").then(
        (res) => {
          this.notices = res.data.data;
          // TODO
          // this.lastPage = res.data.total_page
        },
      );
    },
    dayCalculate(to_datetime) {
      var now = new Date();
      var datetime = new Date(to_datetime);

      var day = Math.ceil(
        (now.getTime() - datetime.getTime()) / (1000 * 3600 * 24),
      );

      var text = "";
      if (day > 0) {
        text = "투표종료";
      } else if (day == 0) {
        var time = new Date(0, 0, 0, 0, 0, 0, datetime - now);
        text = time.getHours() + "시 " + time.getMinutes() + "분 남음";
      } else {
        text = "D-" + day * -1;
      }

      return text;
    },
    checkAndMove(vote) {
      let leftMinutes = parseInt(
        (new Date(vote.to_datetime).getTime() - new Date().getTime()) /
          (1000 * 60),
      );
      let beforeMinutes = parseInt(
        (new Date(vote.from_datetime).getTime() - new Date().getTime()) /
          (1000 * 60),
      );

      if (leftMinutes < 0) {
        // 기간 만료 시
        this.$router.push({ name: "voteDetail", params: { id: vote.id } });
      } else if (beforeMinutes > 0) {
        // 투표 가능시간 이전
        this.votepopup = true;
        this.votepopupmsg = `투표 시작시간 ${vote.from_datetime} 이후 투표가능합니다.`;
      } else if (vote.vote_yn == "Y") {
        // 이미 투표진행 경우
        this.$router.push({ name: "voteDetail", params: { id: vote.id } });
      } else {
        this.$router.push({ name: "voteDetail", params: { id: vote.id } });
      }
    },
    fallbackFunction() {
      let browserInfo = navigator.userAgent.toLowerCase();
      if (browserInfo.indexOf("android") > 0) {
        const marketUrl = LYNNLIFE_STORE_URL["android"];
        window.location.replace(marketUrl);
      } else if (
        browserInfo.indexOf("iphone") > 0 ||
        browserInfo.indexOf("ipad") > 0
      ) {
        const marketUrl = LYNNLIFE_STORE_URL["ios"];
        window.location.replace(marketUrl);
      } else {
        this.$store.commit(
          "SUCCESS",
          "모바일 스마트린 앱을 설치하여야 이용이 가능합니다.",
        );
        return;
      }
    },
    // 노크타운 앱 이동 (구버전 앱은 ForceUpdateDialog에서 업데이트 처리)
    movetoNocktown() {
      window.location.href = NOCKTOWN_DEEP_LINK;
    },
    movetoLynnPass() {
      try {
        this.loadingBar = true;

        let browserInfo = navigator.userAgent.toLowerCase();
        if (browserInfo.indexOf("wikey_flutter") > 0) {
          // 웹뷰인 경우
          if (this.user.is_accepted) {
            let vm = this;
            window.flutter_inappwebview
              .callHandler("gotoLynnpass", this.$store.getters.getIdToken)
              .then(function(result) {
                vm.loadingBar = false;
                console.log(
                  "@@@ flutterInAppWebViewPlatformReady gotoLynnpass result: ",
                  result,
                );
              });
          } else {
            this.loadingBar = false;
            this.$store.commit("SUCCESS", "입주자를 위한 서비스입니다.");
          }
        } else {
          // 모바일 웹
          window.location.href = "woomi://com.woomi.lynnlife";
          setTimeout(this.fallbackFunction, 250); // 설치된 어플이 없을 경우 market으로 이동
          this.loadingBar = false;
        }
      } catch (e) {
        this.loadingBar = false;
        console.log(e);
      }
    },
    movetoFlutter() {
      if (this.loadingBar) return;
      try {
        this.loadingBar = true;

        let browserInfo = navigator.userAgent.toLowerCase();
        if (browserInfo.indexOf("wikey_flutter") > 0) {
          // 웹뷰인 경우
          if (this.user.is_accepted) {
            return window.flutter_inappwebview
              .callHandler("gotoSmartHome", this.$store.getters.getIdToken)
              .then((result) => {
                console.log(
                  "@@@ flutterInAppWebViewPlatformReady gotoSmartHome  result: ",
                  result,
                );
              })
              .catch((error) => {
                alert(
                  "스마트홈에 연결할 수 없습니다. 앱을 재시작하거나 잠시 후 다시 시도해 주세요.",
                );

                this.$store.dispatch("LOGGING", {
                  error: error.message || error,
                  tags: `flutter_inappwebview|intro_gotoSmartHome_failed(${this
                    .user?.email || "unknown"})`,
                  etc: {},
                });
              })
              .finally(() => {
                this.loadingBar = false;
              });
          } else {
            this.loadingBar = false;
            this.$store.commit("SUCCESS", "입주자를 위한 서비스입니다.");
          }
        } else {
          // 모바일 웹
          window.location.href = "woomi://com.woomi.lynnlife";
          setTimeout(this.fallbackFunction, 250); // 설치된 어플이 없을 경우 market으로 이동
          this.loadingBar = false;
        }
      } catch (e) {
        this.loadingBar = false;
        console.log(e);
      }
    },
    checkSurvey() {
      const query = {
        location: "tenant",
        skip_ids: this.$store.getters.getSurveySkipList,
      };
      checkSurvey(this.home.id, query).then(({ data }) => {
        console.log(data);
        this.survey = data;
        this.survey.dialog = true;
      });
    },

    openDefectView(defectType) {
      let to = "";
      let isSettingOpen = false;
      let endAt = "";
      let type = "";
      let name = "DefectList";

      if (defectType == "PRE") {
        to = "/defects/pre/list?type=PRE";
        isSettingOpen = this.home.is_defect_pre_open;
        endAt = this.home.defect_pre_end_at;
        name = "DefectPreList";
        type = "PRE";
      } else if (defectType == "AFTER") {
        to = "/defects/list?type=AFTER";
        isSettingOpen = this.home.is_defect_after_open;
        endAt = this.home.defect_after_end_at;
        type = "AFTER";
      }

      if (!endAt) {
        endAt = "";
      }

      this.callFlutter(type, isSettingOpen, endAt);
      // fix: router 처리 방식 수정.
      // this.$router.push(to)
      this.$router.push({ name: name, query: { type: type } });
    },
    // home의 사전점검여부에 따라 flutter 호출
    callFlutter(defectType, isSettingOpen = false, endAt = null) {
      // Note: 로직 변경 시, Contract.vue/DwellingIntro.vue 둘 다 변경 필요

      // 전체 단지 사전점검만 flutter 앱 사용
      if (defectType != "PRE") return;

      // 해당 하자접수 오픈여부 체크
      if (!isSettingOpen) return;

      console.log("run callFlutter type: ", defectType, " is App", this.is_app);
      if (this.is_app) {
        let dong = this.home.dong_no;
        let ho = this.home.ho_no;
        let siteCode = this.home.erp_village_id;
        let siteName = this.home.village_name;
        let home_id = this.home.id;
        let email = this.user.email;
        let mobile = this.user.mobile;

        // 사전점검 종료일자
        // let endAt = endAt;
        window.flutter_inappwebview
          .callHandler(
            "setCustomerDefectData",
            defectType,
            siteCode,
            siteName,
            dong,
            ho,
            home_id,
            email,
            endAt,
            mobile,
          )
          .then(function(result) {
            console.log(
              "@@@ flutterInAppWebViewPlatformReady setCustomerDefectData  result: ",
              result,
            );
          })
          .catch((e) => {
            console.log("###e", e);

            // client error 저장
            this.$store.dispatch("LOGGING", {
              error: e,
              tags: `flutter_inappwebview|setCustomerDefectData()`,
              etc: {},
            });
          });
      }
    },
    getFacilityListAPI() {
      if (this.facilityList.length > 0) {
        this.showFacilityHome = true;
      }

      getFacilityList("is_simple=Y")
        .then((res) => {
          const facilityList = res.data;
          this.$store.commit("SET_FACILITY_LIST", facilityList);
          this.showFacilityHome = facilityList.length > 0;
        })
        .catch((err) => {
          this.showFacilityHome = false;
        });
    },
  },
  created() {
    if (!this.home) {
      alert("입주자 인증이 승인되지 않았습니다.");
      this.$router.push({ name: "mypage" });
      return;
    }

    getMonth(this.home.id).then((res) => {
      if (this.$route.params.year) {
        this.thisYear = this.$route.params.year;
        this.thisMonth = this.$route.params.month;
      } else {
        this.thisYear = res.data.year;
        this.thisMonth = res.data.month;
      }
      this.maxYear = res.data.year;
      this.maxMonth = res.data.month;
      this.getFeeList();
    });
    this.getFacilityListAPI();
    this.getNoticeList();
    this.getVoteList();
    this.checkSurvey();
    this.getServiceFeeList();
  },
};
</script>
